const doc = [({"installment":"Πληρωμή με δόσεις", "limited_subscription":"Περιορισμένη εγγραφή", "one_time":"Εφάπαξ", "subscription":"Εγγραφή"})];
module.exports = doc.length <= 1 ? doc[0] : doc;